import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { templatePacks, TemplatePack } from '../data/templatePacks';
function PackCard({
  pack,
  index
}: {
  pack: TemplatePack;
  index: number;
}) {
  const [current, setCurrent] = useState(0);
  const count = pack.images.length;
  useEffect(() => {
    if (count < 2) return;
    const id = setInterval(() => {
      setCurrent(prev => (prev + 1) % count);
    }, 1500);
    return () => clearInterval(id);
  }, [count]);
  return <motion.article initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.4,
    delay: index % 2 * 0.05,
    ease: [0.23, 1, 0.32, 1]
  }} className="bg-deco-cream rounded-2xl sm:rounded-[1.5rem] p-2.5 sm:p-4 border border-deco-aqua/30 overflow-hidden" data-id="element-173" data-mp="25svxrc7yaup9">
      <div className="relative aspect-square rounded-xl sm:rounded-2xl overflow-hidden bg-white" data-id="element-174" data-mp="kdgcs96xgyjm">
        {count === 0 ? <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-deco-aqua-soft text-deco-forest/50 px-3 text-center" data-id="element-175" data-mp="1t3uy6ybls09r">
            <Sparkles size={20} data-id="element-176" data-mp="1f3aelzxv60f7" />
            <span className="text-[10px] sm:text-xs font-medium leading-tight" data-id="element-177" data-mp="1f66dbqhjct4p">
              Vista previa próximamente
            </span>
          </div> : <AnimatePresence initial={false} data-id="element-178" data-mp="15dh6j8wxk3fp">
            <motion.img key={current} src={pack.images[current]} alt={`Plantilla del pack ${pack.name}`} drag={count > 1 ? 'x' : false} dragConstraints={{
          left: 0,
          right: 0
        }} dragElastic={0.18} onDragEnd={(_, info) => {
          if (info.offset.x < -40) setCurrent(prev => (prev + 1) % count);
          if (info.offset.x > 40) setCurrent(prev => (prev - 1 + count) % count);
        }} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.45,
          ease: [0.23, 1, 0.32, 1]
        }} className="absolute inset-0 w-full h-full object-contain p-2 sm:p-4 cursor-grab active:cursor-grabbing select-none" draggable={false} data-id="element-179" data-mp="1a4z4rp7kjpwz" />
          </AnimatePresence>}
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1.5 sm:gap-2 pt-2.5 sm:pt-3.5 px-1" data-id="element-180" data-mp="r7fjnatll29m">
        <h3 className="font-serif text-[13px] sm:text-lg text-deco-forest font-semibold leading-tight" data-id="element-181" data-mp="m7kpmyeizwkc">
          {pack.name}
        </h3>
        {count > 1 && <div className="flex items-center gap-1 shrink-0" aria-hidden="true" data-id="element-182" data-mp="cag4n1wf2754">
            {pack.images.map((src, i) => <span key={src} className={`h-1.5 rounded-full transition-all duration-300 ${i === current ? 'w-3 bg-deco-brick' : 'w-1.5 bg-deco-aqua/50'}`} data-id="element-183" data-mp="322386ooahfy5" data-mpi={i} />)}
          </div>}
      </div>
    </motion.article>;
}
export function TemplatePacks() {
  return <section className="bg-deco-beige py-14 sm:py-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-184" data-mp="1mhkbvbol0lts">
      <div className="max-w-4xl mx-auto" data-id="element-185" data-mp="1r8u2oflv9v79">
        <p className="text-center text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-deco-brick mb-4" data-id="element-186" data-mp="1r9vg2qqcuts5">
          Dentro del Bono 2
        </p>
        <h2 className="text-center font-serif text-2xl sm:text-4xl text-deco-forest font-semibold mb-4" data-id="element-187" data-mp="208h24vv1cqxo">
          Descubre algunos de los{' '}
          <span className="italic text-deco-brick" data-id="element-188" data-mp="2568ufqzlef2e">packs incluidos</span>
        </h2>
        <p className="text-center text-[13px] sm:text-sm text-deco-forest/60 max-w-xl mx-auto mb-10 sm:mb-12 leading-relaxed" data-id="element-189" data-mp="2a6n5zj0ek756">
          Más de 300 plantillas listas para imprimir, organizadas en diferentes
          temáticas para que siempre encuentres un diseño que quieras crear.
        </p>

        <div className="grid grid-cols-2 gap-3 sm:gap-5" data-id="element-190" data-mp="268xzlt6yniz5">
          {templatePacks.map((pack, i) => <PackCard key={pack.name} pack={pack} index={i} data-id="element-191" data-mp="21b67ay2eluuf" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}